export const ADMIN_MANAGEMENT_SECTIONS = {
  users: "Usuarios",
  suppliers: "Proveedores",
};

export const DEFAULT_ADMIN_MANAGEMENT_SECTION = "users";
